import React from 'react';

import Currency from '../Currency';
import bem from '../../utils/bem';
import { obtenerCuotaMensual, obtenerCuotaMinicuotas } from '../../utils/constants';
import { toDecimals } from '../../utils/helpers';
import AgeCapitalLogo from './SVG/CapitalLogo.png';

import './FinanceOption.scss';
import Button from '../Button';

const MinicuotasOption = ({
  financeOption,
  prime,
  financingAmount,
  selectFinancingOption,
  selectedFinancingOptionsNumber,
  resetAdd,
  plazo,
  shouldUseCapitalStyle,
  finalPrice,
  minicuotaInsurance,
  insurancePrice,
  primeSecure,
  carPrice
}) => {
  return (
    <>
      <div className="finance-option__general">
        <div className="finance-option__image-container">
            <img src={AgeCapitalLogo} alt="CapitalLogo" className="finance-option__image" />
            <h3>Minicuotas</h3>
        </div>
        <div className="finance-option__conditions">
          <div className="finance-option__conditions-item">
            <h4>Prima</h4>
            <span className="gold">{toDecimals(financeOption?.min_prima)}%</span>
          </div>
          <div className="finance-option__conditions-item">
            <h4>Plazo</h4>
            <span className="gold">{Math.round(financeOption?.months_period)} meses</span>
          </div>
        </div>
      </div>
      <div className="finance-option__amounts">
        <div className="finance-option__amounts-item">
          <h4 className="gold">Mini cuota 12 meses</h4>
            <span>
              aproximada {insurancePrice > 0 ? "con":"sin"} seguro:&nbsp;
              <Currency
                className="gold"
                value={obtenerCuotaMinicuotas(
                  finalPrice,
                  financingAmount,
                  true,
                  insurancePrice,
                  primeSecure,
                  carPrice
                )}
              />
            </span>
        </div>
        <div className="finance-option__amounts-item">
          <h4 className="gold">Mini cuota mes 13 en adelante</h4>
            <span>
              aproximada {insurancePrice > 0 ? "con":"sin"} seguro:&nbsp;
              <Currency
                className="gold"
                value={obtenerCuotaMinicuotas(
                  finalPrice,
                  financingAmount,
                  false,
                  insurancePrice,
                  primeSecure,
                  carPrice
                )}
              />
            </span>
            
        </div>
        <div className="finance-option__amounts-item">
          <Button gold ui="circular" component={'a'} target="_blank" href="https://veinsamotors.com/wp-content/uploads/2021/07/Reglamento_MINI-CUOTAS-AGE-CAPITAL.pdf">
            <span>Ver Reglamento</span>
          </Button>
        </div>
        <div className="finance-option__quote-container finance-option__quote-container--center">
          <span className="disclaimer">Cuota mensual aproximada sujeta a aprobación.</span>
        </div>
      </div>
    </>
  );
}
const NormalFinanceOption = ({
  financeOption,
  prime,
  financingAmount,
  selectFinancingOption,
  selectedFinancingOptionsNumber,
  resetAdd,
  plazo,
  shouldUseCapitalStyle
}) => {
  return (
    <>
      <div className="finance-option__general">
        <div className="finance-option__image-container">
          <img
            src={financeOption.image_url}
            alt={financeOption.nombre}
            className="finance-option__image"
          />
          {financeOption?.post_type?.toLocaleLowerCase().indexOf('leasing') !== -1 && (
            <span className="finance-option__leasing">
              Leasing
            </span>
          )}
        </div>
        <div className="finance-option__info">
          <div className="finance-option__prime">
            Datos calculados con:{' '}
            <span className="bold">{Math.round(prime || 0)}% de prima.</span>
          </div>
          <div className="finance-option__interest">
            Tasa primer año:{' '}
            <span className="bold">{toDecimals(financeOption?.interes)}%</span>
          </div>
          <div className="finance-option__term">
            Plazo:{' '}
            <span className="bold">{Math.round(plazo || 0)} meses</span>
          </div>
          <div className="finance-option__quote">
            Cuota mensual aproximada sin seguro:{' '}
            <span className="bold">
              <Currency
                value={obtenerCuotaMensual(
                  financeOption.interes,
                  plazo,
                  financingAmount
                )}
              />
            </span>
          </div>
        </div>
      </div>
      <div className="finance-option__quote-container">
        <div className="finance-option__amount">
          Monto a financiar:{' '}
          <span className="bold">
            <Currency value={financingAmount} />
          </span>
        </div>
      </div>
      <div className="finance-option__quote-container finance-option__quote-container--center">
        <span className="disclaimer">Cuota mensual aproximada sujeta a aprobación.</span>
      </div>
    </>
  );
}
const FinanceOption = ({
  financeOption,
  prime,
  financingAmount,
  selectFinancingOption,
  selectedFinancingOptionsNumber,
  resetAdd,
  plazo,
  shouldUseCapitalStyle,
  option,
  hasPromo,
  finalPrice,
  minicuotaInsurance,
  insurancePrice,
  primeSecure,
  carPrice,
  amountOriginal,
}) => {
  return (
    <button
      onClick={() => {
        if (selectedFinancingOptionsNumber >= 1 && !financeOption.isSelected) {
          return resetAdd(financeOption);
        }
        return selectFinancingOption(financeOption);
      }}
      className={bem('finance-option', { selected: financeOption.isSelected, shouldUseCapitalStyle })}
    >
      {!shouldUseCapitalStyle ? 
        <NormalFinanceOption
          shouldUseCapitalStyle={shouldUseCapitalStyle}
          resetAdd={resetAdd}
          key={option.post_type}
          financeOption={option}
          prime={prime}
          financingAmount={financingAmount}
          selectFinancingOption={selectFinancingOption}
          selectedFinancingOptionsNumber={selectedFinancingOptionsNumber}
          plazo={plazo}
          minicuotaInsurance={minicuotaInsurance}
          insurancePrice={insurancePrice}
          primeSecure={primeSecure}
          carPrice={carPrice}
        />
        :<MinicuotasOption 
          shouldUseCapitalStyle={shouldUseCapitalStyle}
          resetAdd={resetAdd}
          key={option.post_type}
          financeOption={option}
          prime={20}
          financingAmount={amountOriginal}
          selectFinancingOption={selectFinancingOption}
          selectedFinancingOptionsNumber={selectedFinancingOptionsNumber}
          plazo={96}
          finalPrice={finalPrice}
          minicuotaInsurance={minicuotaInsurance}
          insurancePrice={insurancePrice}
          primeSecure={primeSecure}
          carPrice={carPrice}
        />}

    </button>
  );
};

export default FinanceOption;